import { Grid } from '@mui/material';
import Transport from './global-variable-tables/factors/Transport';
import Fuel from './global-variable-tables/factors/Fuel';
import Gwp from './global-variable-tables/factors/Gwp';
import ConversionFactors from './global-variable-tables/factors/ConversionFactors';
import EmissionFactors from './global-variable-tables/factors/EmissionFactors';

const Factors = () => {
    return (
        <Grid container>
            <Grid item xs={12} sx={{ p: 2 }}>
                <>
                    <Transport />
                    <Fuel />
                    <Gwp />
                    <ConversionFactors />
                    <EmissionFactors />
                </>
            </Grid>
        </Grid>
    )
}

export default Factors
